/**
 * Solutions for Google PageSpeed Insights.
 * Consult AG before making updates.
 */

// Remove visibility: hidden; for CLS on page load
window.addEventListener('load', function() {
    document.body.style = '';
});

// Lazy-load JavaScript files on minimal user interaction (MUI)
var jsLoaded = false,
    mui = false,
    loadJS = function() {
        if(!jsLoaded) {
            var script = document.querySelector('script[data-src]');

            if(script) {
                script.src = script.dataset.src;
                script.removeAttribute('data-src');
                script.addEventListener('load', loadJS);
            } else {
                jsLoaded = true;
            }
        }

        // Trigger MUI for third-party scripts added in Google Tag Manager
        if(!mui) {
            if(typeof dataLayer !== 'undefined') {
                dataLayer.push({'event': 'minimal-user-interaction'});
            }

            mui = true;
        }
    };

document.addEventListener('focus', loadJS, {once: true});
document.addEventListener('mousemove', loadJS, {once: true});
document.addEventListener('scroll', loadJS, {once: true});
document.addEventListener('touchstart', loadJS, {once: true});
document.addEventListener('keydown', loadJS, {once: true});
